import { MessageTemplateOptions } from "./types";

export const document = ({ link, form }: MessageTemplateOptions) => ({
  link,
  text: form.title,
  html: `<a href="${link}">${form.title}</a>`,
});
